import React from 'react';
import { motion } from 'framer-motion';
export function RiskReversalSection() {
  const objections = [{
    q: '"¿Puedo hacer esto solo? Vi que en internet se puede."',
    a: 'Sí, técnicamente puedes. Igual que puedes cortarte el cabello tú mismo. La pregunta real es: ¿Sabes qué hacer después de registrar? ¿Conoces tus responsabilidades anuales? ¿Sabrías cómo evitar que tu empresa quede inactiva? Registrar es un paso. Crear un negocio funcional es un proceso completo. Inkova te acompaña en todo ese proceso.'
  }, {
    q: '"No vivo en Estados Unidos. ¿Puedo igual?"',
    a: 'Sí. Trabajamos con emprendedores latinos en todo el mundo que quieren operar en USA. Tú no necesitas estar físicamente en Estados Unidos para tener una empresa allá. Solo necesitas la guía correcta.'
  }, {
    q: '"¿Y si ya tengo mi LLC creada?"',
    a: 'Perfecto. Podemos ayudarte con lo que sigue: estructura, cumplimiento anual, identidad o presencia digital. En Inkova entramos donde estés.'
  }, {
    q: '"¿Por qué no usar un abogado?"',
    a: 'Inkova no es un despacho de abogados y no reemplaza el asesoramiento legal especializado. Lo que hacemos es acompañarte en el proceso de registro, darte estructura, dirección y herramientas claras para que tu negocio funcione desde el inicio. Si tu caso requiere asesoramiento legal específico, te lo decimos con honestidad y te orientamos.'
  }, {
    q: '"¿$590 no es mucho para empezar?"',
    a: 'Considera lo contrario: ¿Cuánto cuesta equivocarse? ¿Cuánto cuesta registrar mal tu empresa y tener que rehacerlo? ¿Cuánto cuesta no saber qué hacer y perder meses en el proceso? $590 no es un gasto. Es la base de todo lo que viene después. Y dentro de ese valor ya está incluido el fee que se paga al estado.'
  }, {
    q: '"¿Cómo sé que Inkova es confiable?"',
    a: 'Porque detrás de Inkova hay una persona real con nombre, cara y trayectoria verificable. Annysol Navarro. Notaria certificada en Florida. Más de 8 años en administración empresarial en USA. Disponible por WhatsApp, Instagram y correo. No somos anónimos. Somos responsables.'
  }];
  return <section className="py-24 bg-inkova-light" data-id="element-394">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-395">
        <div className="text-center mb-16" data-id="element-396">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-serif text-inkova-primary mb-6" data-id="element-397">
            Sabemos lo que estás&nbsp;pensando.
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-xl text-gray-700 font-light" data-id="element-398">
            Y tenemos una respuesta honesta para&nbsp;cada&nbsp;duda.
          </motion.p>
        </div>

        <div className="space-y-8" data-id="element-399">
          {objections.map((obj, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100" data-id="element-400">
              <h3 className="text-xl font-bold text-inkova-primary mb-4 italic" data-id="element-401">
                {obj.q}
              </h3>
              <p className="text-gray-700 leading-relaxed font-light" data-id="element-402">
                {obj.a}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}